/**
 * Formula group date range — derive calendar bounds for the stats-style picker.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FormulaGroup } from '@trafficpulse/shared';
import { getRangeFromPreset } from '@/components/date-range';
import type { StatsDateRangePreset } from '@/components/date-range';

export function formulaGroupToFromTo(
  group: Pick<FormulaGroup, 'dateRange' | 'dateRangeCustomFrom' | 'dateRangeCustomTo'>,
): { from: string; to: string } {
  if (group.dateRange === 'custom' && group.dateRangeCustomFrom && group.dateRangeCustomTo) {
    return { from: group.dateRangeCustomFrom, to: group.dateRangeCustomTo };
  }
  const preset = group.dateRange as StatsDateRangePreset;
  const r = getRangeFromPreset(preset === 'custom' ? 'last-7-days' : preset);
  if (r) return r;
  return getRangeFromPreset('last-7-days')!;
}
